module.exports = __webpack_public_path__ + "dist/images/84c5bbbbe03a201b22e843911908e6b4.svg";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2416834937/src/pobble-app/client/~/pobble-components/dist/select-role/parent.svg
// module id = 473
// module chunks = 0